/// <amd-module name="Search/Code/Components/Splitter" />

import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { Orientation, Position, Sized, Sizer } from "VSSUI/Sizer";
import { LeftPaneContainer } from "Search/Code/Components/LeftPane";
import { RightPaneContainer } from "Search/Code/Components/RightPane";
import { PreviewOrientationActionIds } from "Search/Code/Constants";
import { ActionCreator } from "Search/Code/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/Code/Flux/StoresHub"
import { css } from "VSSUI/Util";

export interface ISplitterContainerProps extends Container.IContainerProps<StoreName, ActionCreator, IAggregatedState, StoresHub> {
    isFullScreen: boolean;
}

export const SplitterContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub, ISplitterContainerProps>(
    [
        "previewOrientationStore"
    ],
    ({
        previewOrientationStoreState
    }, props) => {
        const { previewOrientation, splitterSize } = previewOrientationStoreState;
        const splitterDirection = previewOrientation === PreviewOrientationActionIds.Bottom ? Orientation.column : Orientation.row;
        let className: string;
        let height: IReadonlyObservableValue<number> | undefined;
        let width: IReadonlyObservableValue<number> | undefined;
        const MinRightPaneWidth = 0.40;
        const MarginAdjustment = 20;
        const MaxSplitterSize = MinRightPaneWidth * (document.body.clientWidth - MarginAdjustment);

        if (props.storesHub.searchStore.isEmptyResponse()) {
            return (<div></div>);
        }

        if (splitterDirection === Orientation.column) {
            className = "flex-column";
            height = splitterSize;
        } else {
            className = "flex-row";
            width = splitterSize;
        }

        return (
            <div className={css("flex-grow scroll-hidden relative", className)}>
                <Sized className={css("flex-column scroll-hidden", props.isFullScreen && "hidden")} height={height} width={width}>
                    <LeftPaneContainer {...props} previewOrientation={previewOrientation} />
                </Sized>
                <Sizer
                    className={css(props.isFullScreen && "hidden")}
                    id="code-results-pane-sizer"
                    minSize={280}
                    maxSize={MaxSplitterSize}
                    onSize={(event, updatedSize: number) => splitterSize.value = updatedSize}
                    onSizeEnd={
                        () => {
                            props.actionCreator.changeSplitterFixedSize(splitterSize.value);
                            fireWindowResize();
                        }
                    }
                    orientation={splitterDirection}
                    position={Position.near}
                    size={splitterSize}
                    tabIndex={0}
                />
                <RightPaneContainer {...props} />
            </div>
        );
    }, () => {
        // Fire window resize once orientation changes or full screen is performed 
        // so that right pane adjusts its width.
        fireWindowResize();
    });

/**
 * fire window resize once re-sizing has ended so that right pane adjusts its width
 */
function fireWindowResize() {
    const event = document.createEvent("Event");
    event.initEvent("resize", false, true);
    window.dispatchEvent(event);
}